<div class="tab-content">
  <!-- Custom tooltip that follows mouse -->
  <div
    *ngIf="tooltipVisible"
    class="custom-contextual-tooltip"
    [style.left.px]="tooltipX"
    [style.top.px]="tooltipY"
    role="tooltip">
    {{ tooltipText }}
  </div>
  <div class="container-fluid px-0">
    <!-- Row 1 -->
    <div class="row consumption-row kt-margin-b-25">
      <div class="col-md-6 consumption-col">
        <div class="chart-card">
          <div class="chart-header">
            <h3>Consumption (lbs)</h3>
            <div class="chart-controls">
              <button type="button" class="sort-btn" (click)="toggleConsumptionBarChartSort()" [title]="consumptionBarChartSort === 'desc' ? 'Sort ascending' : 'Sort descending'">
                <mat-icon>{{ consumptionBarChartSort === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
              </button>
              <button
                *ngIf="shouldShowConsumptionToggle()"
                type="button"
                class="show-all-btn"
                (click)="toggleShowAllConsumptionItems()"
                [title]="getConsumptionToggleTitle()">
                <mat-icon>{{ showAllConsumptionItems ? 'unfold_less' : 'unfold_more' }}</mat-icon>
              </button>
            </div>
          </div>
          <div class="chart-body chart-body-large">
            <div *ngIf="isLoadingConsumption" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingConsumption && hasNoData(consumptionBarChartLabels, consumptionBarChartData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">insert_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No consumption data found for the selected filters</p>
            </div>
            <div class="chart-wrapper" *ngIf="!isLoadingConsumption && !hasNoData(consumptionBarChartLabels, consumptionBarChartData) && consumptionBarChartLabels.length > 0 && consumptionBarChartData.length > 0">
              <canvas baseChart
                #consumptionBarChart
                [labels]="consumptionBarChartLabels"
                [datasets]="consumptionBarChartData"
                [options]="getBarChartOptions(filters.breakdownBy !== 'product')"
                [colors]="barChartColors"
                [chartType]="'bar'">
              </canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 consumption-col">
        <div class="data-card">
          <h3>Consumption Data (lbs)</h3>
          <div class="table-container">
            <div *ngIf="isLoadingConsumption" class="loading-overlay">
              <div class="spinner-dots">
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
                <div class="spinner-dot"></div>
              </div>
            </div>
            <div *ngIf="!isLoadingConsumption && hasNoData(consumptionBarChartLabels, consumptionBarChartData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">table_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No consumption data found for the selected filters</p>
            </div>
            <table class="data-table" *ngIf="!isLoadingConsumption && !hasNoData(consumptionBarChartLabels, consumptionBarChartData) && consumptionBarChartLabels.length > 0 && consumptionBarChartData.length > 0">
              <thead>
                <tr>
                  <th>{{ filters.breakdownBy !== 'product' ? getBreakdownDisplayName(filters.breakdownBy) : 'Product' }}</th>
                  <!-- Simple format: single column -->
                  <th *ngIf="!isConsumptionStacked()" class="text-right">Current (lbs)</th>
                  <th *ngIf="!isConsumptionStacked() && hasConsumptionCompareData()" class="text-right">Previous (lbs)</th>
                  <!-- Stacked format: one column per product -->
                  <ng-container *ngIf="isConsumptionStacked()">
                    <th *ngFor="let dataset of consumptionBarChartData" class="text-right">{{ dataset.label }}</th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let label of consumptionBarChartLabels; let i = index">
                  <td>
                    <span
                      *ngIf="shouldShowContextualTooltip() && getContextualTooltip(label)"
                      (mouseenter)="onTooltipMouseEnter($event, label)"
                      (mouseleave)="onTooltipMouseLeave()">
                      {{ label }}
                    </span>
                    <span *ngIf="!shouldShowContextualTooltip() || !getContextualTooltip(label)">
                      {{ label }}
                    </span>
                  </td>
                  <!-- Simple format: single value -->
                  <td *ngIf="!isConsumptionStacked()" class="text-right">{{ getConsumptionValue(i) | number:'1.2-2' }}</td>
                  <td *ngIf="!isConsumptionStacked() && hasConsumptionCompareData()" class="text-right">
                    {{ getConsumptionCompareValue(i) | number:'1.2-2' }}
                  </td>
                  <!-- Stacked format: one value per product -->
                  <ng-container *ngIf="isConsumptionStacked()">
                    <td *ngFor="let dataset of consumptionBarChartData; let j = index" class="text-right">
                      {{ getConsumptionValueForProduct(j, i) | number:'1.2-2' }}
                    </td>
                  </ng-container>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td class="font-semibold">Total</td>
                  <!-- Simple format: single total -->
                  <td *ngIf="!isConsumptionStacked()" class="text-right font-semibold">
                    {{ getConsumptionBarChartTotal() | number:'1.2-2' }}
                  </td>
                  <td *ngIf="!isConsumptionStacked() && hasConsumptionCompareData()" class="text-right font-semibold">
                    {{ getConsumptionCompareTotal() | number:'1.2-2' }}
                  </td>
                  <!-- Stacked format: one total per product -->
                  <ng-container *ngIf="isConsumptionStacked()">
                    <td *ngFor="let dataset of consumptionBarChartData; let j = index" class="text-right font-semibold">
                      {{ getConsumptionTotalForProduct(j) | number:'1.2-2' }}
                    </td>
                  </ng-container>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Row 2 -->
    <div class="row consumption-row">
      <div class="col-md-6 consumption-col">
        <div class="chart-card">
          <h3>Consumption Over Time</h3>
          <div class="chart-body chart-body-medium-alt">
            <div *ngIf="isLoadingConsumptionOverTime" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingConsumptionOverTime && hasInsufficientTimeseriesData(consumptionLineChartLabels)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">timeline</mat-icon>
              <h3 class="chart-empty-state__title">Insufficient time range selected</h3>
              <p class="chart-empty-state__subtitle">Please select a wider date range to view trends over time</p>
            </div>
            <div *ngIf="!isLoadingConsumptionOverTime && !hasInsufficientTimeseriesData(consumptionLineChartLabels) && hasNoData(consumptionLineChartLabels, consumptionLineChartData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">timeline</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No consumption data found for the selected filters</p>
            </div>
            <div class="chart-wrapper" *ngIf="!isLoadingConsumptionOverTime && !hasInsufficientTimeseriesData(consumptionLineChartLabels) && !hasNoData(consumptionLineChartLabels, consumptionLineChartData) && consumptionLineChartLabels.length > 0 && consumptionLineChartData.length > 0">
              <canvas baseChart
                #consumptionLineChart
                [labels]="consumptionLineChartLabels"
                [datasets]="consumptionLineChartData"
                [options]="lineChartOptions"
                [colors]="lineChartColors"
                [chartType]="'line'">
              </canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 consumption-col">
        <div class="chart-card">
          <h3>Product Breakdown</h3>
          <div class="chart-body chart-body-medium-alt">
            <div *ngIf="isLoadingConsumption" class="loading-overlay">
              <div class="spinner"></div>
            </div>
            <div *ngIf="!isLoadingConsumption && hasNoData(productBreakdownDonutLabels, productBreakdownDonutData)" class="chart-empty-state">
              <mat-icon class="chart-empty-state__icon">pie_chart</mat-icon>
              <h3 class="chart-empty-state__title">No data available</h3>
              <p class="chart-empty-state__subtitle">No product breakdown data found for the selected filters</p>
            </div>
            <div class="chart-wrapper" *ngIf="!isLoadingConsumption && !hasNoData(productBreakdownDonutLabels, productBreakdownDonutData) && productBreakdownDonutLabels.length > 0 && productBreakdownDonutData.length > 0">
              <canvas baseChart
                #productBreakdownDonutChart
                [labels]="productBreakdownDonutLabels"
                [datasets]="productBreakdownDonutData"
                [options]="productBreakdownDonutChartOptions"
                [colors]="donutChartColors"
                [chartType]="'doughnut'">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

